<template>
  <!-- 头部 -->
  <div class="header show">
    <div class="headerBox">
<!--      <div class="back-btn">
        <img src="@/static/icon/left.svg">
      </div>-->
      <div class="logoBox">
        <a class="logo-sspai" @click="openUrl('/')">
          <img src="@/static/img/logo-hutil.png">
        </a>
      </div>
      <div class="menuBox">

        <template v-for="(menu,index) in menuTree">
          <template v-if="menu.contentType != '3'">
            <div class="menuBox-item" :key="index">
              <a class="menu menu-Matrix">
                <i v-if="scrollFlag" class="iconfont"><img :src="require(`@/static/icon/${menu.iconSrc}-black.svg`)"></i>
                <i v-else class="iconfont"><img :src="require(`@/static/icon/${menu.iconSrc}.svg`)"></i>
                <span>{{ menu.name }}</span>
              </a>
              <div class="subMenu" v-if="menu.children && menu.children.length > 0">
                <div class="submenu-wrapper" v-for="(secondMenu,secondIndex) in menu.children" :key="secondIndex">
                  <div class="submenu-title">
                    <div class="submenu-font">{{secondMenu.name}}</div>
                  </div>
                  <template v-if="secondMenu.children && secondMenu.children.length > 0">
                    <template v-for="(thirdMenu,thirdIndex) in secondMenu.children">
                      <div class="link-wrapper" :key="thirdIndex" v-if="thirdMenu.contentType == '1'">
                        <a @click="openUrl(thirdMenu.routeSrc)">
                          <span class="link-title">{{ thirdMenu.name }}</span>
                        </a>
                      </div>
                      <div class="link-wrapper link-wrapper-logo link-wrapper-Pi" :key="thirdIndex" v-if="thirdMenu.contentType == '2'">
                        <div class="link-wrapper-div">
                          <a  @click="openUrl(thirdMenu.routeSrc)">
                            <img :src="thirdMenu.routeSrc">
                          </a>
                        </div>
                      </div>
                    </template>
                  </template>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <a class="menu" :key="index" @click="openUrl(menu.routeSrc)">
              <template v-if="menu.iconSrc">
                <i v-if="scrollFlag" class="iconfont"><img :src="require(`@/static/icon/${menu.iconSrc}-black.svg`)"></i>
                <i v-else class="iconfont"><img :src="require(`@/static/icon/${menu.iconSrc}.svg`)"></i>
              </template>
              <span>{{menu.name}}</span>
            </a>
          </template>
        </template>
      </div>
      <div class="userBox">
        <div class="icon icon-search">
          <img v-if="scrollFlag" @click="search" src="@/static/icon/search-black.svg">
          <img v-else @click="search" src="@/static/icon/search.svg">
        </div>
        <template v-if="$store.getters.nickName">
          <div class="icon icon-add">
            <el-dropdown @command="dropdownClick">
              <img v-if="scrollFlag" src="@/static/icon/add-black.svg">
              <img v-else src="@/static/icon/add.svg">
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="essay">文章</el-dropdown-item>
                <el-dropdown-item command="post">帖文</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="avatar">
            <img :src="resourceUrl($store.getters.avatar,'avatar')">
          </div>
          <div class="btn-logout">
            <a :underline="false" @click="logoutClick">退出</a>
          </div>
        </template>
        <template v-else>
          <div class="btn-login">
            <a :underline="false" @click="loginClick">登录</a>
          </div>
        </template>
      </div>
    </div>

    <!--  搜索框  -->
<!--    <h-search :open-flag="searchFlag" @close="searchFlag = false"></h-search>-->
    <!--  登录框  -->
    <h-login :open-flag="loginFlag" @close="loginFlag = false"></h-login>

  </div>
</template>

<script>
import HSearch from '@/page/components/h-search'
import HLogin from '@/page/components/h-login'
import { getMenuTree } from '@/api/menuApi'

export default {
  name: 'h-header',
  components: { HLogin, HSearch },
  data() {
    return {
      //页面滚动标志
      scrollFlag: false,
      //搜索框标志
      searchFlag: false,
      //登录框标志
      loginFlag: false,
      menuTree: {}
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.navShow()
      this.getMenuTree()
    },
    getMenuTree() {
      const $this = this;
      getMenuTree({ type: '1' }).then(res => {
        $this.menuTree = res.data;
      })
    },
    /**
     * 登录框点击
     */
    logoutClick() {
      this.$confirm("是否退出？","确认").then(()=>{
        this.$store.dispatch("logout");
      }).catch(()=>{
      })
    },
    /**
     * 登录框点击
     */
    loginClick() {
      this.loginFlag = !this.loginFlag
    },
    /**
     * 搜索图标点击事件
     */
    search() {
      // this.searchFlag = !this.searchFlag
      this.$router.push({ path: '/search'});
    },
    dropdownClick(key){
      switch (key){
        case 'essay':
          this.addEssayClick();
          break;
        case 'post':
          this.addPostClick();
          break;
      }
    },
    addPostClick(){
      let params = {};
      params.type = 'add';
      this.$router.push({ path: '/post',query:params});
    },
    addEssayClick(){
      let params = {};
      params.type = 'add';
      this.$router.push({ path: '/essay',query:params});
    },
    // 滑动滚轮切换头部导航
    navShow() {
    /*  let $this = this
      var header = document.querySelector('.header')
      var mainTitle = document.querySelector('.main-title')
      window.onscroll = function() {
        var docTop = document.documentElement.scrollTop
        if (docTop >= 500) {
          $this.scrollFlag = true
          header.classList.add('header-scroll')
          mainTitle?.classList.add('main-title-fixed')
        } else {
          $this.scrollFlag = false
          header.classList.remove('header-scroll')
          mainTitle?.classList.remove('main-title-fixed')
        }
      }*/
    },
    openUrl(url){
      if (url.startsWith("http")) {
        window.open(url);
      } else {
        this.$router.push({ path: url});
      }

    }
  }
}
</script>

<style scoped>
.userBox {
  display: flex;
  justify-content: space-between;
}

.userBox div{
  width: 30px;
  height: 30px;
  margin: 0 10px;
}

.userBox .icon{
  cursor: pointer;
}
.el-dropdown{
  margin: 0 !important;
}

.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
}
.el-icon-arrow-down {
  font-size: 12px;
}

.userBox .avatar img{
  border-radius: 30px;
}

.userBox .btn-logout{
  display: flex;
  color: #fff;
  font-size: 13px;
  cursor: pointer;
}
.userBox .btn-login{
  color: #fff;
  font-size: 13px;
  cursor: pointer;
  display: flex;
}

.userBox .btn-logout a{
  margin-top: auto;
}
.userBox .btn-login a{
  display: flex;
  margin-top: auto;
}


</style>
